export type IconEntry = {
  emoji: string;
  name: string;
  group: IconGroup;
  gradient: [string, string];
};

export type IconGroup =
  | 'primi'
  | 'pane'
  | 'dolci'
  | 'carne'
  | 'pesce'
  | 'verdura'
  | 'frutta'
  | 'bevande'
  | 'altro';

const GRADIENTS = {
  red: ['#FFD4C2', '#F3856F'] as [string, string],
  peach: ['#FFE4D4', '#F3B88F'] as [string, string],
  gold: ['#FFF2DC', '#E4B068'] as [string, string],
  yellow: ['#FFF0B9', '#F2CF77'] as [string, string],
  green: ['#DCEDD6', '#A6C48B'] as [string, string],
  lavender: ['#E8D9F0', '#B48BC9'] as [string, string],
  blue: ['#D2E5EE', '#85B0C7'] as [string, string],
  clay: ['#FFE1DB', '#D8735D'] as [string, string],
};

export const ICONS: IconEntry[] = [
  // primi
  { emoji: '🍝', name: 'pasta', group: 'primi', gradient: GRADIENTS.red },
  { emoji: '🍕', name: 'pizza', group: 'primi', gradient: GRADIENTS.red },
  { emoji: '🍜', name: 'ramen', group: 'primi', gradient: GRADIENTS.peach },
  { emoji: '🍚', name: 'riso', group: 'primi', gradient: GRADIENTS.yellow },
  { emoji: '🍲', name: 'zuppa', group: 'primi', gradient: GRADIENTS.clay },
  { emoji: '🥘', name: 'padella', group: 'primi', gradient: GRADIENTS.peach },
  { emoji: '🍳', name: 'uova', group: 'primi', gradient: GRADIENTS.yellow },
  // pane
  { emoji: '🍞', name: 'pane', group: 'pane', gradient: GRADIENTS.gold },
  { emoji: '🥐', name: 'croissant', group: 'pane', gradient: GRADIENTS.gold },
  { emoji: '🥖', name: 'baguette', group: 'pane', gradient: GRADIENTS.gold },
  { emoji: '🫓', name: 'focaccia', group: 'pane', gradient: GRADIENTS.gold },
  { emoji: '🥨', name: 'pretzel', group: 'pane', gradient: GRADIENTS.gold },
  { emoji: '🥯', name: 'bagel', group: 'pane', gradient: GRADIENTS.gold },
  // dolci
  { emoji: '🍰', name: 'torta', group: 'dolci', gradient: GRADIENTS.peach },
  { emoji: '🧁', name: 'cupcake', group: 'dolci', gradient: GRADIENTS.peach },
  { emoji: '🍪', name: 'biscotti', group: 'dolci', gradient: GRADIENTS.gold },
  { emoji: '🍩', name: 'ciambella', group: 'dolci', gradient: GRADIENTS.peach },
  { emoji: '🍫', name: 'cioccolato', group: 'dolci', gradient: GRADIENTS.clay },
  { emoji: '🥮', name: 'mooncake', group: 'dolci', gradient: GRADIENTS.gold },
  { emoji: '🎂', name: 'compleanno', group: 'dolci', gradient: GRADIENTS.peach },
  { emoji: '🍨', name: 'gelato', group: 'dolci', gradient: GRADIENTS.peach },
  // carne
  { emoji: '🥩', name: 'bistecca', group: 'carne', gradient: GRADIENTS.clay },
  { emoji: '🍖', name: 'costina', group: 'carne', gradient: GRADIENTS.clay },
  { emoji: '🍗', name: 'pollo', group: 'carne', gradient: GRADIENTS.clay },
  { emoji: '🌭', name: 'hot dog', group: 'carne', gradient: GRADIENTS.clay },
  { emoji: '🍔', name: 'burger', group: 'carne', gradient: GRADIENTS.clay },
  // pesce
  { emoji: '🐟', name: 'pesce', group: 'pesce', gradient: GRADIENTS.blue },
  { emoji: '🍣', name: 'sushi', group: 'pesce', gradient: GRADIENTS.blue },
  { emoji: '🦐', name: 'gambero', group: 'pesce', gradient: GRADIENTS.blue },
  { emoji: '🦀', name: 'granchio', group: 'pesce', gradient: GRADIENTS.blue },
  { emoji: '🦑', name: 'calamaro', group: 'pesce', gradient: GRADIENTS.blue },
  // verdure
  { emoji: '🥗', name: 'insalata', group: 'verdura', gradient: GRADIENTS.green },
  { emoji: '🥬', name: 'verdura', group: 'verdura', gradient: GRADIENTS.green },
  { emoji: '🥦', name: 'broccoli', group: 'verdura', gradient: GRADIENTS.green },
  { emoji: '🌽', name: 'mais', group: 'verdura', gradient: GRADIENTS.yellow },
  { emoji: '🥕', name: 'carota', group: 'verdura', gradient: GRADIENTS.peach },
  { emoji: '🍆', name: 'melanzana', group: 'verdura', gradient: GRADIENTS.lavender },
  { emoji: '🍅', name: 'pomodoro', group: 'verdura', gradient: GRADIENTS.red },
  { emoji: '🥑', name: 'avocado', group: 'verdura', gradient: GRADIENTS.green },
  { emoji: '🌶️', name: 'peperoncino', group: 'verdura', gradient: GRADIENTS.red },
  { emoji: '🧄', name: 'aglio', group: 'verdura', gradient: GRADIENTS.gold },
  { emoji: '🧅', name: 'cipolla', group: 'verdura', gradient: GRADIENTS.lavender },
  { emoji: '🥔', name: 'patata', group: 'verdura', gradient: GRADIENTS.gold },
  { emoji: '🫑', name: 'peperone', group: 'verdura', gradient: GRADIENTS.green },
  // frutta
  { emoji: '🍎', name: 'mela', group: 'frutta', gradient: GRADIENTS.red },
  { emoji: '🍋', name: 'limone', group: 'frutta', gradient: GRADIENTS.yellow },
  { emoji: '🍇', name: 'uva', group: 'frutta', gradient: GRADIENTS.lavender },
  { emoji: '🍓', name: 'fragola', group: 'frutta', gradient: GRADIENTS.clay },
  { emoji: '🍊', name: 'arancia', group: 'frutta', gradient: GRADIENTS.peach },
  { emoji: '🍌', name: 'banana', group: 'frutta', gradient: GRADIENTS.yellow },
  { emoji: '🍑', name: 'pesca', group: 'frutta', gradient: GRADIENTS.peach },
  { emoji: '🍉', name: 'anguria', group: 'frutta', gradient: GRADIENTS.red },
  // bevande
  { emoji: '🍷', name: 'vino', group: 'bevande', gradient: GRADIENTS.lavender },
  { emoji: '🍺', name: 'birra', group: 'bevande', gradient: GRADIENTS.gold },
  { emoji: '🍹', name: 'cocktail', group: 'bevande', gradient: GRADIENTS.peach },
  { emoji: '☕', name: 'caffè', group: 'bevande', gradient: GRADIENTS.clay },
  { emoji: '🍵', name: 'tè', group: 'bevande', gradient: GRADIENTS.green },
  { emoji: '🥛', name: 'latte', group: 'bevande', gradient: GRADIENTS.gold },
  // altro
  { emoji: '🧀', name: 'formaggio', group: 'altro', gradient: GRADIENTS.gold },
  { emoji: '🥓', name: 'pancetta', group: 'altro', gradient: GRADIENTS.clay },
  { emoji: '🫕', name: 'fonduta', group: 'altro', gradient: GRADIENTS.gold },
  { emoji: '🍿', name: 'popcorn', group: 'altro', gradient: GRADIENTS.yellow },
  { emoji: '🥫', name: 'conserve', group: 'altro', gradient: GRADIENTS.red },
  { emoji: '🍯', name: 'miele', group: 'altro', gradient: GRADIENTS.gold },
];

export const DEFAULT_ICON: IconEntry = ICONS.find((i) => i.emoji === '🍳')!;

const TAG_ALIASES: Record<string, string> = {
  primo: 'pasta',
  primi: 'pasta',
  secondo: 'pollo',
  secondi: 'pollo',
  dolce: 'torta',
  dolci: 'torta',
  dessert: 'torta',
  contorno: 'insalata',
  contorni: 'insalata',
  antipasto: 'formaggio',
  antipasti: 'formaggio',
  vegetariano: 'verdura',
  vegano: 'verdura',
  veloce: 'pasta',
  veloci: 'pasta',
  classico: 'pasta',
  inverno: 'zuppa',
  estate: 'insalata',
  autunno: 'zuppa',
  primavera: 'insalata',
  aperitivo: 'vino',
  aperitivi: 'vino',
  colazione: 'croissant',
  brunch: 'croissant',
  mare: 'pesce',
  lievitati: 'pane',
  biscotto: 'biscotti',
  torta: 'torta',
  crudo: 'sushi',
  sano: 'insalata',
  healthy: 'insalata',
  picnic: 'insalata',
  festa: 'compleanno',
  compleanno: 'compleanno',
};

export function iconForTag(tag: string): IconEntry | undefined {
  const t = tag.toLowerCase().trim();
  if (!t) return undefined;
  const exact = ICONS.find((i) => i.name === t);
  if (exact) return exact;
  if (TAG_ALIASES[t]) {
    return ICONS.find((i) => i.name === TAG_ALIASES[t]);
  }
  return ICONS.find((i) => t.includes(i.name) || (i.name.length > 3 && i.name.includes(t)));
}

export function iconForName(name: string): IconEntry | undefined {
  const lower = name.toLowerCase();
  for (const icon of ICONS) {
    if (lower.includes(icon.name)) return icon;
  }
  return undefined;
}

const CATEGORY_TO_EMOJI: Record<string, string> = {
  ANTIPASTO: '🧀',
  PRIMO: '🍝',
  SECONDO: '🍗',
  CONTORNO: '🥗',
  'PIATTO UNICO': '🥘',
  DOLCE: '🍰',
};

export function resolveIcon(recipe: {
  icon?: string | null;
  category?: string | null;
  tags?: string[];
  name?: string;
}): IconEntry {
  if (recipe.icon) {
    const found = ICONS.find((i) => i.emoji === recipe.icon);
    if (found) return found;
  }
  if (recipe.name) {
    const m = iconForName(recipe.name);
    if (m) return m;
  }
  if (recipe.category) {
    const em = CATEGORY_TO_EMOJI[recipe.category];
    if (em) {
      const found = ICONS.find((i) => i.emoji === em);
      if (found) return found;
    }
  }
  for (const tag of recipe.tags ?? []) {
    const m = iconForTag(tag);
    if (m) return m;
  }
  return DEFAULT_ICON;
}

export const ICON_GROUPS: { key: IconGroup; label: string }[] = [
  { key: 'primi', label: 'Primi' },
  { key: 'pane', label: 'Pane' },
  { key: 'dolci', label: 'Dolci' },
  { key: 'carne', label: 'Carne' },
  { key: 'pesce', label: 'Pesce' },
  { key: 'verdura', label: 'Verdure' },
  { key: 'frutta', label: 'Frutta' },
  { key: 'bevande', label: 'Bevande' },
  { key: 'altro', label: 'Altro' },
];
